import PropTypes from 'prop-types';
import React from 'react';

import Auth from '../../../../utils/Auth';
import { SNOW_CREATE_INCIDENT_URL } from '../../../../utils/constants';
import { openLink } from '../../../../utils/ej-utils';
import ButtonWhite from '../../ButtonWhite';
import './JournalViewError.css';

const JournalViewError = (props) => (
  <div>
    <div className="error-banner">
      <div className="text-color-error">
        {`An unexpected error has occured while displaying the Journal View for the transaction UUID: "${props.transactionUUID}"`}
        <p>
          <ButtonWhite
            className="m3-sm error-btn"
            label="Create SNOW Ticket"
            onClick={() => openLink(SNOW_CREATE_INCIDENT_URL)}
          />
        </p>
      </div>
      {Auth.getAuthGroups().has('App.ElectronicJournal.ADMIN') && (
        <div>
          Alternatively you can view the Transaction Representation by clicking
          on the Switch View button.
        </div>
      )}
    </div>
  </div>
);
JournalViewError.defaultProps = {
  transactionUUID: '',
};

JournalViewError.propTypes = {
  transactionUUID: PropTypes.string,
};
export default JournalViewError;
